"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = exports.SIZES = exports.STYLES = void 0;
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
require("./Textarea.scss");
exports.STYLES = Object.freeze({
    DEFAULT: 'default',
});
exports.SIZES = Object.freeze({
    MEDIUM: 'medium',
    LARGE: 'large',
    FULL_WIDTH: 'full-width',
});
const TextareaWithRef = (0, react_1.forwardRef)((props, ref) => {
    const { label = null, style = exports.STYLES.DEFAULT, size = exports.SIZES.MEDIUM, disabled = false, errorMessage = null, hasError = false, placeholder = '', value = null, required = false, tabIndex = 1, autoFocus = false, maxLength, rows, autocomplete = 'off', onChange = () => { }, onBlur = () => { }, onFocus = () => { }, onKeyPress = () => { }, onKeyDown, onSubmit = () => { }, onClick = () => { }, onDrop, resize, } = props;
    const handleKeyDown = react_1.default.useCallback((e) => {
        if (e.keyCode === 13) {
            onSubmit();
        }
    }, [onSubmit]);
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)('ds-textarea', style, size, {
            disabled,
            'has-error': hasError,
        }) },
        label && react_1.default.createElement("div", { className: 'input-label' }, label),
        react_1.default.createElement("div", { className: 'group-container' },
            react_1.default.createElement("div", { className: 'input-container' },
                react_1.default.createElement("textarea", { ref: ref, style: { resize }, placeholder: (0, maybe_unwrap_1.unwrapMaybe)(placeholder), disabled: disabled, autoFocus: autoFocus, value: value === null ? undefined : value, required: required, tabIndex: tabIndex, maxLength: maxLength, autoComplete: autocomplete, onChange: (e) => onChange(e.target.value), onKeyPress: onKeyPress, onKeyDown: onKeyDown || handleKeyDown, onBlur: onBlur, onFocus: onFocus, rows: rows === null ? undefined : rows, onDrop: onDrop
                        ? (e) => {
                            e.preventDefault();
                            onDrop(e);
                        }
                        : undefined, onDragOver: onDrop
                        ? (e) => {
                            e.preventDefault();
                        }
                        : undefined }))),
        hasError && (0, util_1.isValue)(errorMessage) ? react_1.default.createElement(_ui_1.Err, { message: errorMessage }) : null));
});
TextareaWithRef.displayName = 'TextAreaWithRef';
const MemoizedTextarea = (0, react_1.memo)(TextareaWithRef);
MemoizedTextarea.displayName = 'Textarea';
exports.Textarea = MemoizedTextarea;
